import { normalizeDisplayName } from "../shared/competition.ts";
import type { PuzzleProgress, SavedState, StorageLike } from "./storage.ts";

export const PLAYER_PROFILE_KEY = "whats-the-code:player";

export interface PlayerProfile {
  name: string;
  autoJoin: boolean;
}

export function loadPlayerProfile(storage: StorageLike, history?: SavedState): PlayerProfile {
  try {
    const raw = storage.getItem(PLAYER_PROFILE_KEY);
    if (raw !== null) {
      const value: unknown = JSON.parse(raw);
      if (value && typeof value === "object") {
        const saved = value as Partial<PlayerProfile>;
        return { name: normalizeDisplayName(saved.name) ?? "", autoJoin: saved.autoJoin !== false };
      }
      return { name: "", autoJoin: false };
    }
  } catch {
    return { name: "", autoJoin: false };
  }

  const recent = Object.values(history?.progress ?? {}).sort((left, right) => right.date.localeCompare(left.date));
  for (const progress of recent) {
    const name = normalizeDisplayName(progress.leaderboardName);
    if (!name) continue;
    const profile = { name, autoJoin: true };
    savePlayerProfile(storage, profile);
    return profile;
  }
  return { name: "", autoJoin: true };
}

export function savePlayerProfile(storage: StorageLike, profile: PlayerProfile): void {
  try {
    storage.setItem(PLAYER_PROFILE_KEY, JSON.stringify({
      name: normalizeDisplayName(profile.name) ?? "",
      autoJoin: profile.autoJoin,
    }));
  } catch {
    return;
  }
}

export function shouldAutoPublish(progress: PuzzleProgress, profile: PlayerProfile, today: string): boolean {
  return profile.autoJoin && normalizeDisplayName(profile.name) !== undefined &&
    progress.date === today && progress.status === "solved" && progress.ranked === true &&
    Boolean(progress.runId) && !progress.leaderboardName && !progress.leaderboardAutoJoinSuppressed;
}